<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">{{ data.platform_name }} 售后服务</div>
<div class="content">
  <div class="subtitle">
    您的申请已成功受理，我们将在24小时内完成修复，并补偿您的等待时间，感谢您的理解与配合！
  </div>
  <div class="button">
    <div class="button">
      <button (click)="close()">确定</button>
    </div>
  </div>
</div>
